/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IngestionLogsErrorDto } from './IngestionLogsErrorDto';
import {
    IngestionLogsErrorDtoFromJSON,
    IngestionLogsErrorDtoFromJSONTyped,
    IngestionLogsErrorDtoToJSON,
    IngestionLogsErrorDtoToJSONTyped,
} from './IngestionLogsErrorDto';

/**
 * 
 * @export
 * @interface IngestionLogsResponseDto
 */
export interface IngestionLogsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IngestionLogsResponseDto
     */
    uploadId: string;
    /**
     * 
     * @type {boolean}
     * @memberof IngestionLogsResponseDto
     */
    completed: boolean;
    /**
     * 
     * @type {number}
     * @memberof IngestionLogsResponseDto
     */
    receivedChunks: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionLogsResponseDto
     */
    totalChunks: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionLogsResponseDto
     */
    insertedCount: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionLogsResponseDto
     */
    failedCount: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionLogsResponseDto
     */
    processedFileCount: number;
    /**
     * 
     * @type {number}
     * @memberof IngestionLogsResponseDto
     */
    skippedEntryCount: number;
    /**
     * 
     * @type {Array<IngestionLogsErrorDto>}
     * @memberof IngestionLogsResponseDto
     */
    errors: Array<IngestionLogsErrorDto>;
    /**
     * 
     * @type {string}
     * @memberof IngestionLogsResponseDto
     */
    sourceName?: string;
}

/**
 * Check if a given object implements the IngestionLogsResponseDto interface.
 */
export function instanceOfIngestionLogsResponseDto(value: object): value is IngestionLogsResponseDto {
    if (!('uploadId' in value) || value['uploadId'] === undefined) return false;
    if (!('completed' in value) || value['completed'] === undefined) return false;
    if (!('receivedChunks' in value) || value['receivedChunks'] === undefined) return false;
    if (!('totalChunks' in value) || value['totalChunks'] === undefined) return false;
    if (!('insertedCount' in value) || value['insertedCount'] === undefined) return false;
    if (!('failedCount' in value) || value['failedCount'] === undefined) return false;
    if (!('processedFileCount' in value) || value['processedFileCount'] === undefined) return false;
    if (!('skippedEntryCount' in value) || value['skippedEntryCount'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    return true;
}

export function IngestionLogsResponseDtoFromJSON(json: any): IngestionLogsResponseDto {
    return IngestionLogsResponseDtoFromJSONTyped(json, false);
}

export function IngestionLogsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IngestionLogsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadId': json['uploadId'],
        'completed': json['completed'],
        'receivedChunks': json['receivedChunks'],
        'totalChunks': json['totalChunks'],
        'insertedCount': json['insertedCount'],
        'failedCount': json['failedCount'],
        'processedFileCount': json['processedFileCount'],
        'skippedEntryCount': json['skippedEntryCount'],
        'errors': ((json['errors'] as Array<any>).map(IngestionLogsErrorDtoFromJSON)),
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
    };
}

export function IngestionLogsResponseDtoToJSON(json: any): IngestionLogsResponseDto {
    return IngestionLogsResponseDtoToJSONTyped(json, false);
}

export function IngestionLogsResponseDtoToJSONTyped(value?: IngestionLogsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uploadId': value['uploadId'],
        'completed': value['completed'],
        'receivedChunks': value['receivedChunks'],
        'totalChunks': value['totalChunks'],
        'insertedCount': value['insertedCount'],
        'failedCount': value['failedCount'],
        'processedFileCount': value['processedFileCount'],
        'skippedEntryCount': value['skippedEntryCount'],
        'errors': ((value['errors'] as Array<any>).map(IngestionLogsErrorDtoToJSON)),
        'sourceName': value['sourceName'],
    };
}

